import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;

// 🌟 1. Thunk to perform manager project action
export const handleProjectAction = createAsyncThunk(
    "projectAction/handleProjectAction",
    async ({ projectid, userid, action }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                `${BackendURL}/projectaction/manageraction`,
                { projectid, userid, action },
                { withCredentials: true }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: "Server Error" }
            );
        }
    }
);

// 🌟 2. Slice
const projectActionSlice = createSlice({
    name: "projectAction",
    initialState: {
        loading: false,
        success: false,
        error: null,
        message: "",
        updatedProject: null,
    },
    reducers: {
        resetProjectActionState: (state) => {
            state.loading = false;
            state.success = false;
            state.error = null;
            state.message = "";
            state.updatedProject = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // 📌 Pending
            .addCase(handleProjectAction.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.error = null;
            })
            // 📌 Success
            .addCase(handleProjectAction.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload.message;
                state.updatedProject = action.payload.project;
            })
            // 📌 Failed
            .addCase(handleProjectAction.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.error = action.payload?.message || "Something went wrong";
            });
    },
});

export const { resetProjectActionState } = projectActionSlice.actions;

export default projectActionSlice.reducer;
